// Components
import DetailsButton from '@/common-utils/components/renders/detailsButton/DetailsButton';
// Common
import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import simGroupFields from '../../../fields/simGroupFields';
import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';
import RouteUrls from '@/app/root/enums/RouteUrls';
import Permissions from '@/app/permissions/Permissions';
// Lang
import SIM_CARDS_TABS from '@/app/root/enums/tabs/SimCardsTabs';
import RenderDataUnit from '../../dataUnit/RenderDataUnit';
import RenderSimOperator from '../../simOperator/RenderSimOperator';

export const columnsSimGroupsId = 'simGroups';
export const columnsSimGroups = (headerPackage) => {

    return ([
        generateColumnDefByField({
            field: simGroupFields.DETAILS,
            headerPackage: headerPackage,
            customCellFn: ({ row }) => (
                <DetailsButton
                    pathParams={{ groupId: row.original.uuid }}
                    baseUrl={RouteUrls.SIM_CARDS_GROUP_DETAILS.url}
                    urlParams={{ view: SIM_CARDS_TABS.SIM_GROUPS.name }}
                    requiredPermissions={[Permissions.SIM_READ.name]}
                />
            ),
            show: !headerPackage.selectionMode
        }),
        generateColumnDefByField({
            field: simGroupFields.ORGANIZATION,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: simGroupFields.TARIFF_DATA,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const dataUnit = getObjectAttributeFromStringKey(cell.row.original,
                    generateNestedFieldAccessor(simGroupFields.TARIFF_DATA_UNIT));
                return (
                    cell.getValue() &&
                    <RenderDataUnit cellData={cell.getValue()} dataUnit={dataUnit} />
                );
            }
        }),

        generateColumnDefByField({
            field: simGroupFields.PROVIDER,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                return <RenderSimOperator iccidOperators={[cell.getValue()]} textSize='text-sm' />;
            }
        }),
        generateColumnDefByField({
            field: simGroupFields.CONSUMPTION_PERCENTAGE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                return (
                    cell.getValue() ?
                        <div>
                            {(cell.getValue() * 100).toFixed()}
                        </div>
                        : null);
            }
        }),
        generateColumnDefByField({
            field: simGroupFields.ACTIVATED_SIMS,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: simGroupFields.DATA_CONSUMPTION,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const data = cell.getValue() ? (cell.getValue() / 1024 / 1024).toFixed(3) : null;
                const dataUnit = getObjectAttributeFromStringKey(cell.row.original,
                    generateNestedFieldAccessor(simGroupFields.TARIFF_DATA_UNIT));
                return (
                    data &&
                    <RenderDataUnit cellData={data} dataUnit={dataUnit} />
                );
            }
        }),
        generateColumnDefByField({
            field: simGroupFields.TOTAL_DATA,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const dataUnit = getObjectAttributeFromStringKey(cell.row.original,
                    generateNestedFieldAccessor(simGroupFields.TARIFF_DATA_UNIT));
                return (
                    cell.getValue() &&
                    <RenderDataUnit cellData={cell.getValue()} dataUnit={dataUnit} />
                );
            }
        })
    ]);
};